import { render, staticRenderFns } from "./bson_tips.vue?vue&type=template&id=37ab95cc&"
import script from "./bson_tips.vue?vue&type=script&lang=js&"
export * from "./bson_tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports